import axios from "axios";
import React, { useState } from "react";
import toast from "react-hot-toast";

const DeleteConfirmationModal = ({
  issue,
  editStatusChanged,
  onClose,
  isOpen,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  console.log("deleteTo", issue);
  const deleteIssue = () => {
    setIsLoading(true);
    let config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/issues/delete/${issue._id}`,
      headers: {},
    };

    console.log("config", issue._id);

    axios
      .request(config)
      .then((response) => {
        setIsLoading(false);
        console.log("------> issues ", response.data);
        toast.success(response.data.message);
        editStatusChanged(); // update status on ui by calling getAllIssues Again
        // onSave({ ...issue, ...data });
        onClose(); // Close the modal
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
        toast.error(error.message);
        editStatusChanged(); // update status on ui by calling getAllIssues Again
        // onSave({ ...issue, ...data });
        onClose(); // Close the modal
      });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg shadow-lg w-11/12 sm:w-1/3 p-6">
        <h2 className="text-lg font-semibold text-gray-700 mb-4">
          Are you sure you want to delete this issue?
        </h2>
        <p className="text-sm text-gray-500 mb-6">
          This action cannot be undone.
        </p>
        <div className="flex justify-end gap-4">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition"
          >
            Cancel
          </button>
          <button
            onClick={deleteIssue}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
          >
            Delete
          </button>
        </div>
      </div>
      {isLoading && (
        <div className="fixed inset-0 h-screen w-screen flex items-center justify-center bg-black bg-opacity-50">
          <span class="loader"></span>
        </div>
      )}
    </div>
  );
};

export default DeleteConfirmationModal;
